import { Component ,ViewChild, inject,ElementRef, HostListener } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { COMMA, ENTER,TAB } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { LiveAnnouncer} from '@angular/cdk/a11y';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import moment from 'moment-timezone';
import { ImageCroppedEvent, LoadedImage ,Dimensions,ImageTransform} from "ngx-image-cropper";
import { DomSanitizer } from "@angular/platform-browser";
import { getLocalJSON } from '../../../_helpers/storage.util';

declare var $:any;

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent {

  public dropdownSettings: IDropdownSettings;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA,TAB];
  addOnBlur = true;
  public certificate: any = [];
  public achivement: any = [];
  public fruits:any=[];
  announcer = inject(LiveAnnouncer);
  public bankDetail:any=[];
  public otherSelection1:any='';
  public termData:any=[];
  public amount1_max:any=500;
  public amount2_max:any=1500;
  public amount3_max:any=3000;
  public amount4_max:any=6000;
  public amount1_min:any=2;
  public amount2_min:any=6;
  public amount3_min:any=12;
  public amount4_min:any=24;

  public croppedImage1:any='';

  // public amount1_max:any=this.service.exchangeCurrency(1,'USD',100);;
  // public amount2_max:any=this.service.exchangeCurrency(1,'USD',300);;
  // public amount3_max:any=this.service.exchangeCurrency(1,'USD',600);;
  // public amount4_max:any=this.service.exchangeCurrency(1,'USD',1200);;
  // public amount_min:any=this.service.exchangeCurrency(1,'USD',2);;


  public loading:boolean = false;
  public submitted:boolean = false;
  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public message: any;
  public countryList:any=[];
  public stateList:any=[];
  public cityList:any=[];
  public genderList:any=[];
  public raceList:any=[];
  public abilityList:any=[];
  public colorList:any=[];
  public planList:any=[];
  public expertList:any=[];
  public allmasterData:any={};
  public loginDetail:any =[];
  public CurrentDetail:any=[];
  public ssd:any=1;
  public colorCode:any='#808080';
  public otherSelection:any='';
  public expertSelected:any=[];
  public expertname:any='';
  public expertname1:any='';
  public expertiseSearch:any='';
  public expertiseDropdownOpen:boolean=false;
  public readonly expertiseMax:number=4;
  public planSelected:any=[];
  public planname:any='';
  public planSearch:any='';
  public planDropdownOpen:boolean=false;
  public readonly planMax:number=4;
  public creatorTypeList:any=[];
  public creatorTypeSelected:any=[];
  public creatorTypename:any='';
  public creatorTypeSearch:any='';
  public creatorTypeDropdownOpen:boolean=false;
  public readonly creatorTypeMax:number=3;
  public readonly organisationExpertiseName:string='Organisation';
  public age:any=''
  public dob: any;
  public countryCode:any='';
  imageChangedEvent: any = '';
  croppedImage: any = '';
  imgUpdate=0;
  canvasRotation = 0;
  rotation?: number;
  translateH = 0;
  translateV = 0;
  scale = 1;
  aspectRatio = 4 / 3;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {
    translateUnit: 'px'
  };
  imageURL?: string;
  allowMoveImage = false;
  hidden = false;

  public lat : any = 0;
  public lang : any = 0;
  public cityName : any='';
  public address : any='';
  public stateName:any='';
  public countryName:any='';
  public zipcode:any=''
  public maxDate:any=new Date();
  public minDate:any=new Date();
  public currentYear:any='';
  public ReasonList:any=[];

  public timeLeft: number = 60;
  public interval:any;
  public otp: string = '';

  private explicitOverviewVisit = false;


  profileData :any = new FormGroup({
    firstname:new FormControl('',Validators.compose([
      Validators.required ])),
    handlename:new FormControl('',Validators.compose([
      Validators.required ])),
    lastname:new FormControl('',Validators.compose([
      Validators.required ])),    
    email:new FormControl('',Validators.compose([
      Validators.required, Validators.email  ])),
    phone:new FormControl(''),  
    expertise:new FormControl(''),
    creator_type:new FormControl('',Validators.compose([
      Validators.required ])),
    short_blurb:new FormControl('',Validators.compose([
      Validators.required ,Validators.maxLength(140),Validators.minLength(10)])),
    aboutus:new FormControl('',Validators.compose([
      Validators.required ,Validators.maxLength(140),Validators.minLength(10) ])),
    org_number:new FormControl(''),
    org_name:new FormControl(''),    
    org_phone:new FormControl(''),
    country_code :new FormControl(''),
    color:new FormControl('',Validators.compose([
      Validators.required ])),  
    address:new FormControl('',Validators.compose([
      Validators.required])),
    color1:new FormControl(''),
    gender:new FormControl(''),
    race:new FormControl(''),
    ability:new FormControl(''),    
    others:new FormControl(''),
    date_of_birth: new FormControl(''),
    amountMonth1:new FormControl(''),
    amountMonth3:new FormControl(''),  
    amountMonth6:new FormControl(''),
    amountMonth12:new FormControl(''),
  })
  
   get f() { return this.profileData.controls; }

   ReviewData = new FormGroup({
    comment:new FormControl('',Validators.compose([
      Validators.required]))  , 
    description:  new FormControl('') 
  })
  get f1() { return this.ReviewData.controls; }

  get isOverviewRoute(): boolean {
    const url = (this.router.url || '').split('?')[0];
    return url === '/edit-profile' || url === '/editprofile';
  }

  get isPresentationRoute(): boolean {
    return (this.router.url || '').split('?')[0] === '/presentation';
  }

  get displayCurrency(): string {
    const detail = this.currentProfile;
    const login = this.loginDetail || {};
    const stripe = detail.stripeDetail || login.stripeDetail || {};
    return (
      detail.userCurrency ||
      login.userCurrency ||
      (stripe.currency || '').toString().toUpperCase() ||
      localStorage.getItem('grw_logincurrency') ||
      'AUD'
    );
  }

  get displayCurrencySymbol(): string {
    const detail = this.currentProfile;
    const login = this.loginDetail || {};
    return (
      detail.userCurrencySymbol ||
      login.userCurrencySymbol ||
      localStorage.getItem('grw_currencySymbol') ||
      '$'
    );
  }

  get displayCurrencyLabel(): string {
    return `${this.displayCurrency} (${this.displayCurrencySymbol})`;
  }

  private get currentProfile(): any {
    return this.CurrentDetail && !Array.isArray(this.CurrentDetail) ? this.CurrentDetail : {};
  }

  private isStripeVerified(profile: any = this.loginDetail): boolean {
    return profile?.stripe_account_verify == true ||
      profile?.stripeDetail?.detail_submitted == true;
  }

  private shouldRedirectToBankAccount(profile: any): boolean {
    return this.isOverviewRoute &&
      profile?.profile_complete == true &&
      !this.isStripeVerified(profile);
  }

  private isExplicitOverviewVisit(): boolean {
    return this.explicitOverviewVisit;
  }

  private shouldAutoRedirectToBankAccount(profile: any): boolean {
    return this.shouldRedirectToBankAccount(profile) && !this.isExplicitOverviewVisit();
  }

  constructor( private sanitizer: DomSanitizer,private el: ElementRef,public router: Router, private route: ActivatedRoute, public service: GlobalService) { 
    window.scroll(0,0);
    this.explicitOverviewVisit = this.route.snapshot.queryParamMap.get('overview') === '1';
    this.getterm();
    this.getReasons();
    var self=this,ss:any=[] ;
    this.currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentDate = new Date().getDate();
    this.maxDate = new Date(this.currentYear - 18, currentMonth, currentDate);  
    this.minDate = new Date(this.currentYear - 100, currentMonth, currentDate);  
    this.loginDetail = getLocalJSON('grw_login');
    this.allmasterData = getLocalJSON('grw_materData');
    if(this.loginDetail.stripe_account_verify){
      if(this.loginDetail.userCurrency !='' && this.loginDetail.userCurrency !='AUD'){
        setTimeout(()=>{
          self.amount1_min= self.service.exchangeCurrency(1,'AUD',self.amount1_min);
          self.amount2_min= self.service.exchangeCurrency(1,'AUD',self.amount2_min);
          self.amount3_min= self.service.exchangeCurrency(1,'AUD',self.amount3_min);
          self.amount4_min= self.service.exchangeCurrency(1,'AUD',self.amount4_min);
          self.amount1_max= self.service.exchangeCurrency(1,'AUD',self.amount1_max);
          self.amount2_max= self.service.exchangeCurrency(1,'AUD',self.amount2_max);
          self.amount3_max= self.service.exchangeCurrency(1,'AUD',self.amount3_max);
          self.amount4_max= self.service.exchangeCurrency(1,'AUD',self.amount4_max);
        },200)
      }
    }
 
    this.allmasterData.genders.filter((el:any)=>{
      el.chcecked = false;
      if(!el.primarySelected){
        ss.push (el);
      }
    })
    this.genderList=ss;  
    this.abilityList=this.allmasterData.ability;  
    this.raceList=this.allmasterData.race; 
    this.allmasterData.subscription.filter((el:any)=>{
      el.amount='';
    }) 
    this.planList=this.allmasterData.subscription;  
    this.allmasterData.expertise.filter((el:any)=>{
      el.chcecked= false;
    })
    // Creator Type shares the Single Content "Type" master list.
    this.creatorTypeList = (this.allmasterData.type || []).filter((el:any)=>{
      return el.childContent == false;
    })
    if(this.loginDetail.user_role_type ==3){
      this.expertList = this.allmasterData.expertise.filter((el:any)=>{
        return el.isCreator == true;
      }); 
      // this.colorList=this.allmasterData.primary_pillars;  
      this.allmasterData.primary_pillars.filter((el:any)=>{
        if(el.isOrganization == false ) {
          self.colorList.push(el);
        }
      })
      this.profileData.controls["date_of_birth"].setValidators([Validators.required]);
      this.profileData.controls["date_of_birth"].updateValueAndValidity();
      this.profileData.controls["gender"].setValidators([Validators.required]);
      this.profileData.controls["gender"].updateValueAndValidity();
      this.profileData.controls["race"].setValidators([Validators.required]);
      this.profileData.controls["race"].updateValueAndValidity();
      this.profileData.controls["ability"].setValidators([Validators.required]);
      this.profileData.controls["ability"].updateValueAndValidity();
      this.profileData.controls["expertise"].setValidators([Validators.required]);
      this.profileData.controls["expertise"].updateValueAndValidity();      
    } else {    
      this.profileData.controls["org_name"].setValidators([Validators.required ,Validators.minLength(6)]);
      this.profileData.controls["org_name"].updateValueAndValidity();
      this.profileData.controls["org_number"].setValidators([Validators.required, Validators.minLength(6)]);
      this.profileData.controls["org_number"].updateValueAndValidity();
      this.profileData.controls["country_code"].setValidators([Validators.required, ]);
      this.profileData.controls["country_code"].updateValueAndValidity();
      this.profileData.controls["org_phone"].setValidators([Validators.required,Validators.minLength(6), Validators.maxLength(10)]);
      this.profileData.controls["org_phone"].updateValueAndValidity();
      this.setOrganisationExpertise();
      this.allmasterData.primary_pillars.filter((el:any)=>{
        if(el.isOrganization == true ) {
          self.colorList.push(el);
        }
      })
    }
    this.CurrentDetail = this.loginDetail;
    this.hydrateProfileForm(this.loginDetail);
    if (this.shouldAutoRedirectToBankAccount(this.loginDetail)) {
      this.router.navigate(['/bank-account']);
      return;
    }
    this.getCountry();
    this.getProfile();
  }


  add(event: MatChipInputEvent,type:any): void {
    var mm:any=[];
    if(type ==1 ){
      mm= this.achivement;
    } else {
      mm=this.certificate;
    }
    
    const value = (event.value || '').trim();
    if (value) {
      if(mm.length <5){
        mm.push({name: value});
      }
    }
    if(type ==1 ){
      this.achivement = mm;
    } else {
      this.certificate =mm;
    }
    event.chipInput!.clear();
  }

  remove(fruit: any ,type:any): void {
    var mm:any=[];
    if(type ==1 ){
      mm= this.achivement;
    } else {
      mm=this.certificate;
    }
    const index = mm.indexOf(fruit);
    if (index >= 0) {
      mm.splice(index, 1);
      this.announcer.announce(`Removed ${fruit}`);
    }
    if(type ==1 ){
      this.achivement = mm;
    } else {
      this.certificate =mm;
    }
  }

  edit(fruit: any, event: any ,type:any) {
    var mm:any=[];
    if(type ==1 ){
      mm= this.achivement;
    } else {
      mm=this.certificate;
    }
    const value = event.value.trim();
    if (!value) {
      this.remove(fruit,type);
      return;
    }
    const index = mm.indexOf(fruit);
    if (index >= 0) {
      mm[index].name = value;
    }
    if(type ==1 ){
      this.achivement = mm;
    } else {
      this.certificate =mm;
    }
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParamMap.has('overview')) {
      const path = (this.router.url || '').split('?')[0];
      this.router.navigateByUrl(path, { replaceUrl: true });
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 4,
      allowSearchFilter: true,
      limitSelection:4,
    };
  }

  /** Organisations always carry the single fixed, read-only "Organisation" expertise. */
  private setOrganisationExpertise(){
    var fixed:any = (this.allmasterData.expertise || []).find((el:any)=>{
      return el.name == this.organisationExpertiseName;
    })
    if(fixed){
      this.expertList=[fixed];
      this.expertSelected=[fixed];
      this.expertname=fixed._id;
      this.profileData.controls['expertise'].setValue([fixed]);
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(){
    if(this.creatorTypeDropdownOpen){
      this.closeCreatorTypeDropdown();
    }
    if(this.expertiseDropdownOpen){
      this.closeExpertiseDropdown();
    }
    if(this.planDropdownOpen){
      this.closePlanDropdown();
    }
  }

  get filteredExpertise(): any[] {
    const term = (this.expertiseSearch || '').trim().toLowerCase();
    if(!term){
      return this.expertList;
    }
    return this.expertList.filter((el:any)=>{
      return (el.name || '').toLowerCase().includes(term);
    })
  }

  get expertiseLimitReached(): boolean {
    return this.expertSelected.length >= this.expertiseMax;
  }

  toggleExpertiseDropdown(){
    this.expertiseDropdownOpen = !this.expertiseDropdownOpen;
    if(this.expertiseDropdownOpen){
      this.closeCreatorTypeDropdown();
      this.closePlanDropdown();
    } else {
      this.expertiseSearch='';
    }
  }

  closeExpertiseDropdown(){
    this.expertiseDropdownOpen=false;
    this.expertiseSearch='';
  }

  isExpertiseSelected(item:any): boolean {
    return this.expertSelected.some((el:any)=>{
      return el._id == item._id;
    })
  }

  toggleExpertise(item:any){
    if(this.isExpertiseSelected(item)){
      this.removeExpertise(item);
      return;
    }
    if(this.expertiseLimitReached){
      this.service.warningAlert('A maximum of '+this.expertiseMax+' expertise options can be selected. Remove one to add another.');
      return;
    }
    this.expertSelected = this.expertSelected.concat([item]);
    this.changeExpertise();
  }

  removeExpertise(item:any, event?:any){
    if(event){
      event.stopPropagation();
    }
    this.expertSelected = this.expertSelected.filter((el:any)=>{
      return el._id != item._id;
    })
    this.changeExpertise();
  }

  changeExpertise(){
    var ids:any=[];
    var hasOther=false;
    this.expertSelected.filter((el:any)=>{
      if(ids.indexOf(el._id) == -1){
        ids.push(el._id);
      }
      if(el.childContent == true){
        hasOther=true;
      }
    })
    this.otherSelection = hasOther
      ? (this.expertSelected.find((el:any)=> el.childContent == true)?._id || '')
      : '';
    this.expertname = ids.join(' , ');
    this.profileData.controls['expertise'].setValue(this.expertSelected.length ? this.expertSelected : '');
    this.profileData.controls['expertise'].updateValueAndValidity();
  }

  get filteredCreatorTypes(): any[] {
    const term = (this.creatorTypeSearch || '').trim().toLowerCase();
    if(!term){
      return this.creatorTypeList;
    }
    return this.creatorTypeList.filter((el:any)=>{
      return (el.name || '').toLowerCase().includes(term);
    })
  }

  get creatorTypeLimitReached(): boolean {
    return this.creatorTypeSelected.length >= this.creatorTypeMax;
  }

  toggleCreatorTypeDropdown(){
    this.creatorTypeDropdownOpen = !this.creatorTypeDropdownOpen;
    if(this.creatorTypeDropdownOpen){
      this.closeExpertiseDropdown();
      this.closePlanDropdown();
    } else {
      this.creatorTypeSearch='';
    }
  }

  closeCreatorTypeDropdown(){
    this.creatorTypeDropdownOpen=false;
    this.creatorTypeSearch='';
  }

  isCreatorTypeSelected(item:any): boolean {
    return this.creatorTypeSelected.some((el:any)=>{
      return el._id == item._id;
    })
  }

  toggleCreatorType(item:any){
    if(this.isCreatorTypeSelected(item)){
      this.removeCreatorType(item);
      return;
    }
    if(this.creatorTypeLimitReached){
      this.service.warningAlert('A maximum of '+this.creatorTypeMax+' creator types can be selected. Remove one to add another.');
      return;
    }
    this.creatorTypeSelected = this.creatorTypeSelected.concat([item]);
    this.changeCreatorType();
  }

  removeCreatorType(item:any, event?:any){
    if(event){
      event.stopPropagation();
    }
    this.creatorTypeSelected = this.creatorTypeSelected.filter((el:any)=>{
      return el._id != item._id;
    })
    this.changeCreatorType();
  }

  changeCreatorType(){
    var ids:any=[];
    this.creatorTypeSelected.filter((el:any)=>{
      if(ids.indexOf(el._id) == -1){
        ids.push(el._id);
      }
    })
    this.creatorTypename = ids.join(' , ');
    this.profileData.controls['creator_type'].setValue(this.creatorTypename);
    this.profileData.controls['creator_type'].updateValueAndValidity();
  }

  get filteredPlans(): any[] {
    const term = (this.planSearch || '').trim().toLowerCase();
    if(!term){
      return this.planList;
    }
    return this.planList.filter((el:any)=>{
      return (el.name || '').toLowerCase().includes(term);
    })
  }

  get planLimitReached(): boolean {
    return this.planSelected.length >= this.planMax;
  }

  togglePlanDropdown(){
    this.planDropdownOpen = !this.planDropdownOpen;
    if(this.planDropdownOpen){
      this.closeCreatorTypeDropdown();
      this.closeExpertiseDropdown();
    } else {
      this.planSearch='';
    }
  }

  closePlanDropdown(){
    this.planDropdownOpen=false;
    this.planSearch='';
  }

  isPlanSelected(item:any): boolean {
    return this.planSelected.some((el:any)=>{
      return el._id == item._id;
    })
  }

  togglePlan(item:any){
    if(this.isPlanSelected(item)){
      this.removePlan(item);
      return;
    }
    if(this.planLimitReached){
      this.service.warningAlert('A maximum of '+this.planMax+' subscription plans can be selected. Remove one to add another.');
      return;
    }
    this.planSelected = this.planSelected.concat([{...item}]);
    this.syncPlanSelection();
  }

  removePlan(item:any, event?:any){
    if(event){
      event.stopPropagation();
    }
    this.planSelected = this.planSelected.filter((el:any)=>{
      return el._id != item._id;
    })
    this.syncPlanSelection();
  }

  syncPlanSelection(){
    this.changeSelection(2);
    this.profileData.controls['color1'].setValue(this.planSelected.length ? this.planSelected : '');
    this.profileData.controls['color1'].updateValueAndValidity();
    this.syncAmountControlsFromPlans();
  }

  private clearAmountValidators(): void {
    ['amountMonth1', 'amountMonth3', 'amountMonth6', 'amountMonth12'].forEach((name) => {
      this.profileData.controls[name].clearValidators();
      this.profileData.controls[name].updateValueAndValidity({ emitEvent: false });
    });
  }

  private syncAmountControlsFromPlans(): void {
    let amountMonth1: any = '';
    let amountMonth3: any = '';
    let amountMonth6: any = '';
    let amountMonth12: any = '';
    (this.planSelected || []).forEach((el: any) => {
      if (el.name == '1 Month') amountMonth1 = el.amount;
      if (el.name == '3 Month') amountMonth3 = el.amount;
      if (el.name == '6 Month') amountMonth6 = el.amount;
      if (el.name == 'Yearly') amountMonth12 = el.amount;
    });
    this.profileData.patchValue({
      amountMonth1,
      amountMonth3,
      amountMonth6,
      amountMonth12,
    }, { emitEvent: false });
  }

  private collectPlanSubscriptions(userdetail: any, applyAmountValidators: boolean): number {
    let hasOneMonth = 0;
    this.clearAmountValidators();
    if (applyAmountValidators) {
      this.syncAmountControlsFromPlans();
    }
    (this.planSelected || []).forEach((el: any) => {
      if (el.name == '1 Month') {
        hasOneMonth = 1;
        if (applyAmountValidators) {
          this.profileData.controls['amountMonth1'].setValidators([
            Validators.required,
            Validators.min(this.amount1_min),
            Validators.max(this.amount1_max),
          ]);
          this.profileData.controls['amountMonth1'].updateValueAndValidity();
        }
      }
      if (el.name == '3 Month' && applyAmountValidators) {
        this.profileData.controls['amountMonth3'].setValidators([
          Validators.required,
          Validators.min(this.amount2_min),
          Validators.max(this.amount2_max),
        ]);
        this.profileData.controls['amountMonth3'].updateValueAndValidity();
      }
      if (el.name == '6 Month' && applyAmountValidators) {
        this.profileData.controls['amountMonth6'].setValidators([
          Validators.required,
          Validators.min(this.amount3_min),
          Validators.max(this.amount3_max),
        ]);
        this.profileData.controls['amountMonth6'].updateValueAndValidity();
      }
      if (el.name == 'Yearly' && applyAmountValidators) {
        this.profileData.controls['amountMonth12'].setValidators([
          Validators.required,
          Validators.min(this.amount4_min),
          Validators.max(this.amount4_max),
        ]);
        this.profileData.controls['amountMonth12'].updateValueAndValidity();
      }
      userdetail.subscription.push({ id: el._id, amount: el.amount, status: 'Active' });
    });
    return hasOneMonth;
  }

  private idOf(value: any): string {
    if (value == null || value === '') {
      return '';
    }
    if (typeof value === 'object') {
      return value._id ? String(value._id) : '';
    }
    return String(value);
  }

  private hydrateProfileForm(data: any = this.CurrentDetail): void {
    const source = (!data || Array.isArray(data) || typeof data !== 'object')
      ? this.loginDetail
      : data;
    if (!source || Array.isArray(source) || typeof source !== 'object') {
      return;
    }

    if (!this.expertSelected?.length && Array.isArray(source.user_expertise) && this.expertList?.length) {
      this.expertSelected = this.expertList.filter((el: any) =>
        source.user_expertise.some((item: any) => this.idOf(item) === String(el._id))
      );
      this.changeExpertise();
    }
    if (!this.creatorTypeSelected?.length && Array.isArray(source.creator_types) && this.creatorTypeList?.length) {
      this.creatorTypeSelected = this.creatorTypeList.filter((el: any) =>
        source.creator_types.some((item: any) => this.idOf(item) === String(el._id))
      );
      this.changeCreatorType();
    }

    this.profileData.patchValue({
      firstname: source.firstName || '',
      lastname: source.lastName || '',
      handlename: source.user_handle || '',
      email: source.email || '',
      phone: source.mobile || '',
      short_blurb: source.short_blurb || '',
      aboutus: source.about_us || '',
      org_number: source.org_reg_number || '',
      org_name: source.org_name || '',
      org_phone: source.org_phone || '',
      country_code: source.phone_code || source.country_code || '',
      color: this.idOf(source.primary_pillar),
      address: source.address || this.address || '',
      gender: this.idOf(source.gender),
      race: this.idOf(source.race),
      ability: this.idOf(source.ability),
      others: source.expertise_other || '',
      date_of_birth: source.dob || this.dob || '',
    }, { emitEvent: false });
    if (this.expertSelected?.length) {
      this.profileData.controls['expertise'].setValue(this.expertSelected, { emitEvent: false });
    }
    if (this.creatorTypename) {
      this.profileData.controls['creator_type'].setValue(this.creatorTypename, { emitEvent: false });
    }
  }

  Onsubmit(type:any){
    var self=this;
    this.hydrateProfileForm();
    this.submitted = true;    
      let userdetail:any = this.profileData;
      userdetail.achivement = '';
      userdetail.certificate = '';
      userdetail.subscription=[];
      
      var count3=0,count4=0 ,count=0 ,count5=0;
      if(type==2){
        if(this.loginDetail.stripe_account_verify==true){
          this.profileData.controls["color1"].setValidators([Validators.required]);
          this.profileData.controls["color1"].updateValueAndValidity();
        }
        if(this.planSelected.length ==0 && this.loginDetail.stripe_account_verify==true){   
          this.service.dangerAlert('Please Add Subscription Detail');
          this.loading=false;
          return
        }   else {
          count5 = this.collectPlanSubscriptions(userdetail, true);
          if(this.loginDetail.user_role_type=='2'){
            if(count5==0){
              this.service.dangerAlert('Please Add 1 month Subscription Detail');
              this.loading=false;
              return;
            }
          }
        }
      } else {
        // Overview must not validate Presentation pricing fields. Those inputs
        // are not in the DOM, so amountMonth* stay empty and fail required/min.
        this.clearAmountValidators();
        if((self.loginDetail.subscriptions || []).length !=0 ){
          count5 = this.collectPlanSubscriptions(userdetail, false);
        }
      }
 

       
      if(this.achivement.length !=0){
        this.achivement.filter((el:any)=>{
          if(count4==0){
            userdetail.achivement = el.name;
          } else {
            userdetail.achivement = el.name +','+userdetail.achivement;
          }
          count4=count4+1;    
        })
      // }   else {
      //   this.service.dangerAlert('Please Add Achivement');
      //   this.loading=false;
      //   return
      }
      if(this.certificate.length !=0){
        this.certificate.filter((el:any)=>{
          if(count3==0){
            userdetail.certificate = el.name;
          } else {
            userdetail.certificate = el.name +','+userdetail.certificate;
          }
          count3=count3+1;    
        })
      // }   else {
      //   this.service.dangerAlert('Please Add Certificate');
      //   this.loading=false;
      //   return
      }
      // if(this.expertname==''){
      //   this.service.dangerAlert('Please Add expertise');
      //   this.loading= false;
      //   return;
      // }    
       
      if(userdetail.valid){
        this.loading=true;
      
       
        var url="/update-profile";
        const saved = this.currentProfile;
        var detail:any={
          "firstName": userdetail.value.firstname || saved.firstName,
  "lastName": userdetail.value.lastname || saved.lastName,
  "mobile": userdetail.value.phone || saved.mobile,
  "short_blurb": userdetail.value.short_blurb || saved.short_blurb,
  "achievement": userdetail.achivement,
  "certifications": userdetail.certificate,
  "user_expertise": this.expertname,
  "creator_type": this.creatorTypename,
  "about_us": userdetail.value.aboutus || saved.about_us,
  "gender": userdetail.value.gender || this.idOf(saved.gender),
  "race": userdetail.value.race || this.idOf(saved.race),
  "ability": userdetail.value.ability || this.idOf(saved.ability),
  "primary_pillar": userdetail.value.color || this.idOf(saved.primary_pillar),
  "address": userdetail.value.address || saved.address,
  "latitude": this.lat,
  "longitude": this.lang,
  "country": this.countryName,
  "state": this.stateName,
  "org_name": userdetail.value.org_name,
  "org_reg_number": userdetail.value.org_number,
  "org_phone": userdetail.value.org_phone,
  "phone_code":userdetail.value.country_code,
  "expertise_other":userdetail.value.others,
  "country_code":userdetail.value.country_code,
        };
        if(this.CurrentDetail.user_role_type==3){
          if (this.profileData.value.date_of_birth != this.dob) {
            this.dob = this.service.ToDate(this.profileData.value.date_of_birth);
            this.profileData.value.date_of_birth = this.dob;
          }
          detail.dob=this.profileData.value.date_of_birth;
        }      
        if(this.zipcode !=''){
          detail.zipcode= this.zipcode;
        }
        if(this.cityName !=''){
          detail.city= this.cityName;
        }
        if(type==2){
          detail.subscription = userdetail.subscription;
        }
        // if(this.CurrentDetail.profile_complete == false ){
        //  detail.gender=userdetail.value.gender;
        // }
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1){             
            this.submitted = false; 
            this.ssd=0; 
              this.getProfile();  
              this.loading=false;          
          } else {
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }), (error:any) => {
        });
      } else{
        const invalidControls: string[] = [];
        Object.keys(userdetail.controls).forEach((controlName) => {
          const control = userdetail.get(controlName);
          if (control && control.invalid) {
            invalidControls.push(controlName);
          }
        });
        console.log(invalidControls, "invalidControls")
        if(invalidControls.length >1){
          this.service.dangerAlert('Please complete mandatory sections.');
        } else {
          var ss='';
          if(invalidControls[0]=='short_blurb'){
            ss='Short blurb';
          }
           else if(invalidControls[0]=='firstname'){
            ss='First name';
          }
           else if(invalidControls[0]=='lastname'){
            ss='Last name';
          }
           else if(invalidControls[0]=='expertise'){
            ss='Expertise';
          }
           else if(invalidControls[0]=='creator_type'){
            ss='Creator type';
          }
          else if(invalidControls[0]=='aboutus'){
            ss='About';
          }
          else if(invalidControls[0]=='color'){
            ss='Profile background';
          }
          else if(invalidControls[0]=='color1'){
            ss='Subscription';
          }
          else if(invalidControls[0]=='address'){
            ss='Location';
          } else if(invalidControls[0]=='date_of_birth'){
            ss='Date of birth';
          }
         else if(invalidControls[0]=='org_number'){
          ss='Organisation number';
        }
       else if(invalidControls[0]=='org_name'){
        ss='Organisation name ';
    } else if(invalidControls[0]=='org_phone'){
      ss='Organisation phone number';
  } else if(invalidControls[0]=='country_code'){
    ss='Country Code';
   } else if(invalidControls[0]=='amountMonth1'){
    ss='Monthly Amount';
  } else if(invalidControls[0]=='amountMonth3'){
    ss='Monthly Amount';
  } else if(invalidControls[0]=='amountMonth6'){
    ss='Monthly Amount';
  } else if(invalidControls[0]=='amountMonth12'){
    ss='Monthly Amount';
  } else {
    ss=invalidControls[0];

  }
          this.service.dangerAlert(ss+' is required.');
        }
        userdetail.markAllAsTouched();
        this.scrollToFirstInvalidControl();  
      }
  }

  getProfile(){ 
    const url = "/profile"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self=this ,kk:any=[],pp:any=[],count:any='';
        if (this.ssd == 1 && this.shouldAutoRedirectToBankAccount(response.data)) {
          this.router.navigate(['/bank-account']);
          return;
        }
        self.achivement=[]; self.certificate=[];
        localStorage.setItem('grw_logincurrency', response.data.userCurrency);
        localStorage.setItem('grw_currencySymbol',response.data.userCurrencySymbol);
        if(response.data.userCurrency !='' && response.data.stripe_account_verify==true && response.data.subscription_added==false){
          this.service.getConversionRate(response.data.userCurrency,2);
        }
        this.lat= response.data.latitude;
        this.lang= response.data.longitude;
        this.cityName=response.data.city;
        this.address=response.data.address;
        this.stateName=response.data.state;
        this.countryName=response.data.country; 
         this.countryCode=response.data.country_code;
        if((response.data.subscriptions || []).length !=0){
          this.planList.filter((ell:any)=>{
            ell.chcecked = false;
            response.data.subscriptions.filter((el:any)=>{
              if(ell._id ==el._id){               
                ell.chcecked = true;
                ell.amount=el.amount;
                pp.push({_id:el._id,name:el.name,amount:el.amount,status:el.status})
              }
          })
        })
        }
        localStorage.setItem('grw_login',<any> JSON.stringify(response.data || {}));
        this.service.setSubject(response.data);
          if((response.data.other_user_expertises || []).length !=0){ 
            self.expertname1=response.data.other_user_expertises[0].content;    
            self.otherSelection= response.data.expertise_other =response.data.other_user_expertises[0].content;
          }
          (this.expertList || []).filter((el:any)=>{
            el.chcecked = false;
            (response.data.user_expertise || []).filter((ell:any)=>{
                if(ell._id ==el._id){
                  el.chcecked= true;
                  kk.push(el);
                  if(!el.childContent){
                    if(self.expertname1==''){
                      self.expertname1=el.name
                    } else {
                      self.expertname1=el.name + ' '+self.expertname1;
                    }
                  }              
                } 
                if(el.childContent == true && el.chcecked == true){
                  self.otherSelection = el._id;
                  if((response.data.other_user_expertises || []).length != 0 ){
                    response.data.expertise_other =response.data.other_user_expertises[0].content;
                  }
                }
              })
          });
    
        var savedCreatorTypes:any=[];
        this.creatorTypeList.filter((el:any)=>{
          (response.data.creator_types || []).filter((ell:any)=>{
            if(ell._id == el._id){
              savedCreatorTypes.push(el);
            }
          })
        })
        this.creatorTypeSelected = savedCreatorTypes;
        this.changeCreatorType();

        this.colorList.filter((ell:any)=>{
          if(ell._id == response.data.primary_pillar){
            self.colorCode = ell.color;
          }
        })
        if(response.data.achievement !=''){
          var jk:any= response.data.achievement.split(',');
          jk.filter((el:any)=>{
            self.achivement.push ({name:el});
          })
        }
       if(response.data.certifications !=''){
        var jk:any= response.data.certifications.split(',');
        jk.filter((el:any)=>{
          self.certificate.push ({name:el});
        })
       }
        var tab12:any = document.getElementById("tab12");
        if (tab12) {
          tab12.style["background-color"] = self.colorCode;
        }
        var tab45:any = document.getElementById("tab45");
        if (tab45) {
          tab45.style["background-color"] = self.colorCode;
        }
        this.CurrentDetail =  response.data;
        if (!this.CurrentDetail.userCurrency && this.CurrentDetail.stripeDetail?.currency) {
          this.CurrentDetail.userCurrency = (this.CurrentDetail.stripeDetail.currency || '').toString().toUpperCase();
        }
        if (!this.CurrentDetail.userCurrencySymbol) {
          this.CurrentDetail.userCurrencySymbol = this.displayCurrencySymbol;
        }
        this.imgURL = response.data.profile_image;
        this.croppedImage= response.data.profile_image;
        this.age = this.CurrentDetail.age;
        this.dob = this.CurrentDetail.dob;
        this.expertSelected = kk;        
        this.planSelected = pp;
        this.syncPlanSelection();
        this.changeExpertise();
        this.hydrateProfileForm(response.data);
        if(response.data.user_role_type !=3){
          this.setOrganisationExpertise();
        }
        this.loginDetail = response.data;
        if(this.loginDetail.userCurrency !='' && this.loginDetail.userCurrency !='AUD'){
          setTimeout(()=>{
            self.amount1_min= self.service.exchangeCurrency(1,'AUD',self.amount1_min);
            self.amount2_min= self.service.exchangeCurrency(1,'AUD',self.amount2_min);
            self.amount3_min= self.service.exchangeCurrency(1,'AUD',self.amount3_min);
            self.amount4_min= self.service.exchangeCurrency(1,'AUD',self.amount4_min);
            self.amount1_max= self.service.exchangeCurrency(1,'AUD',self.amount1_max);
            self.amount2_max= self.service.exchangeCurrency(1,'AUD',self.amount2_max);
            self.amount3_max= self.service.exchangeCurrency(1,'AUD',self.amount3_max);
            self.amount4_max= self.service.exchangeCurrency(1,'AUD',self.amount4_max);
          },300)
        }
        if(response.data.is_default_profile_image==true && localStorage.getItem('grw_upload_iamge')){
          $('#ssdt').trigger('click');
          localStorage.removeItem('grw_upload_iamge');
        } else if(response.data.is_default_profile_image==true && !localStorage.getItem('grw_upload_iamge')){
          $('#firstpasslink111').trigger('click');
        } else if(this.ssd==0 && response.data.is_default_profile_image==true){
          this.service.dangerAlert('Please add a mandatory profile image.');
        }
        else if(!response.data.singles && this.ssd==0 && response.data.stripe_account_verify==true && response.data.subscription_added==true){
          $('#poss11').trigger('click');
        } else if(this.imgUpdate==1){
          if(this.router.url=='/editprofile') {
            this.router.navigate(['/edit-profile']);
          } else {
            this.router.navigate(['/editprofile']);
          }        
        } else {
          if(this.ssd==0 && response.data.profile_complete==true){
            if (this.isOverviewRoute && this.shouldRedirectToBankAccount(response.data)) {
              this.router.navigate(['/bank-account']);
            } else {
              this.router.navigate(['/profile']);
            }
          }
        }
        window.scroll(0,0);
      }
    }), (error) => { this.loading =false; });

  }

  getUploadFileDetail(event: any) {
    this.selectedFile = event[0];
    var mimeType = event[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }
    var reader = new FileReader();
    this.imagePath = event;
    reader.readAsDataURL(event[0]);
    reader.onload = (_event: any) => {
      const image = new Image();
      image.src = _event.target.result;
      image.onload = () => {
        const {
          height,
          width
        } = image;
        // if (height < 1080 || width < 1920) {
        //   this.service.dangerAlert("Image should be at least 1920px by 1080px.");
        //   return false;
        // }
        // this.imgURL = reader.result;
        return true;
      };
    }
  }

  getUploadFileDetail11(event: any) {
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      var mimeType = event.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.message = "Only images are supported.";
        return;
      }
      var reader = new FileReader();
      this.imagePath = event.target.files;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
        this.uploadImage();
      };
    }
  }

  changeImage() {
    $("#file1").trigger("click");
  }

  getCountry(){
    const url = "/country"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.countryList = response.data;
        if(this.loginDetail.bank_account_added ==true){
          this.getBankDetail(); 
        }
      }
    }), (error) => { this.loading =false; });
  }

  uploadImage(){
    this.loading=true;
    var url="/update-profile-image";
    let formdata= new FormData();
    if (this.croppedImage == '') {
      this.service.dangerAlert('Profile Image is Required');
      this.loading = false;
      return
    } else {
      if (this.croppedImage1 != '') {
        const fileObject = this.service.dataURLtoFile(this.croppedImage1, 'album.png');
        formdata.append('profile', fileObject);
      }
    }
    this.service.PostApiFormData(formdata,url).subscribe(((response:any)=>{
      if(response.success ==1){ 
        this.ssd=1;
        this.imgUpdate=1;
        this.croppedImage1='';
        this.showCropper=false;
        // this.
        this.getProfile(); 
        this.loading=false;               
      } else {
        this.loading=false;
      }
    }), (error:any) => {
    });
  }

  delete(){
    if(this.loginDetail.is_collaborator){
      $('#closebtn1').trigger('click');
      this.service.dangerAlert('Please Cancel your subscription first');
      this.router.navigate(['/partners']);
    } else{
      this.submitted=true;
      if(this.ReviewData.valid){
        this.loading=true;
        var url="/delete-account";
        if(this.otherSelection1==''){
          this.ReviewData.controls["description"].setValue('');
        }
        var detail:any={
          "reason_id":this.ReviewData.value.comment,
          "reason":this.ReviewData.value.description
        }
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1) {
            this.submitted=false;
            this.ReviewData.reset();
            $('#closebtn1').trigger('click');
            this.loading=false;
            this.service.logOut();
            this.router.navigate(['/']);
          } else {
            this.loading=false;
          }
        }));
      }
    }
  }

  getCheckboxexData(event:any){ 
    var self=this;
      this.expertList.filter((el:any)=>{
        if(event.target.checked){
          if(event.target.value ==el._id && el.childContent==true){
            self.otherSelection =el._id;
          }
          if(el._id == event.target.value){
            el.chcecked = true;
          }
        } else {
          if(event.target.value ==el._id && el.childContent==true){
            self.otherSelection ='';
          }
          if(el._id == event.target.value){
            el.chcecked = false;
          }
        }        
      })
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    // firstInvalidControl.focus(); //without smooth behavior
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  redirectCheck(){
    if(this.loginDetail.profile_complete ==true){
      if(this.loginDetail.stripe_account_verify==true){
        if(this.loginDetail.subscription_added==true){
          this.router.navigate(['/create-post']);
        } else {
          this.service.dangerAlert('Please complete your Subscription detail');
          this.router.navigate(['/edit-profile']);
        }
      } else {
        $("#passlink111").trigger("click");
      }
    } else {
      this.service.dangerAlert('Please complete your profile first');
    }
  }
  
  onFilterChange(event: any, type: any) {
    if (type == 1) {
    } else if (type == 2) {
    } else if (type == 3) {
    } else if (type == 4) {
    } else {
    }
    console.log(event);
  }

  changeSelection(type:any) {
    var subcatText: any='',self=this,count=0;
    if(type==1){
      if (this.expertSelected.length != 0) {
        this.expertSelected.filter(function (el: any) {
          if (subcatText) {
            subcatText = el._id + " , " + subcatText;
          } else {
            subcatText = el._id;
          }       
          self.expertList.filter((ell:any)=>{
            if(ell._id==el._id && ell.childContent==true){
              count =1;           
            }
          })
          if(count ==1){
            self.otherSelection =el._id;
          } else {
            self.otherSelection ='';
          }
        });
        
        if(subcatText !=''){
          this.expertname= subcatText;
        }
      }
    } else {
      if (this.planSelected.length != 0) {
        this.planSelected.filter(function (el: any) {
          if (subcatText) {
            subcatText = el._id + " , " + subcatText;
          } else {
            subcatText = el._id;
          } 
        });        
        if(subcatText !=''){
          this.planname= subcatText;
        }
      }
      this.planList.filter((el:any)=>{
        this.planSelected.filter((els:any)=>{
          if(el._id ==els._id){
            els.amount =el.amount;
          }
        })        
      })

    }

  }

  getBankDetail(){
    const url = "/get-bank-account"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {      
        response.data[0].account_number = 'XXXXXXXX'+response.data[0].last4
        this.countryList.filter((el:any)=>{
            if(el.code == response.data[0].country){
              response.data[0].country_name =el.name;
            }
        })
        this.bankDetail =response.data[0];
      }
    }), (error) => { this.loading =false; });
  }

  handleAddressChange(address:any){ 
    var city1="",state1="",country1="",zipcode1="",countryCode1='';
    address.address_components.filter(function(el:any) {
      if(el.types[0]=='administrative_area_level_2'){        
        city1= el.long_name;
      }
      if(el.types[0]=='country'){
        country1=el.long_name;
        countryCode1=el.short_name;
      }
      if(el.types[0]=='administrative_area_level_1'){
        state1=el.long_name;
      }
      if(el.types[0]=="postal_code"){
        zipcode1=el.long_name;
      }
    }); 
    this.countryCode=countryCode1;
    this.cityName = city1;
    this.stateName=state1;
    this.countryName=country1;
    this.zipcode=zipcode1;
    this.lat = address.geometry.location.lat();
    this.lang = address.geometry.location.lng();
    this.address = address.formatted_address;
    this.profileData.controls['address'].setValue(address.formatted_address);
  }

  agecalculate(event:any){
    this.age = moment().diff(event.value, 'years') 
  }

  getReasons(){
    const url = "/reason-list"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {     
        this.ReasonList = response.data;
      }
    }), (error) => { this.loading =false; });
  }

  getchek(event:any){
    var self=this;
    self.otherSelection1='';
    this.ReasonList.filter((el:any)=>{
      if(el._id ==event.target.id){
        if(el.childContent){
          self.otherSelection1=el._id;
          self.ReviewData.controls["description"].setValidators([Validators.required,Validators.maxLength(140)]);
          self.ReviewData.controls["description"].updateValueAndValidity();
        }
      }
    })
  }


  numberVerify(type:any){
    if(this.CurrentDetail.phone_code == ''){
      this.service.dangerAlert('Please enter country code first');
      return;
    } else if(this.CurrentDetail.org_phone == ''){  
      this.service.dangerAlert('Add mobile number')
      return
    } else {
      var detail:any={
        "phone_code": this.CurrentDetail.phone_code,
        "mobile": this.CurrentDetail.org_phone
      }
      var url="/mobile-verification-check";
      this.loading=true;
      this.service.PostApis(detail,url).subscribe(((response:any)=>{
        if(response.success){
          if(type==1){
            this.otp='';
            $('#poss').trigger('click');
          }   
          this.service.successAlert(response.message);      
          this.startTimer(); 
          this.loading=false;
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }))
    }
  }

  otpVerify(){
    if (this.otp.length != 4) {
      this.service.dangerAlert('Please enter otp');
      return;
    } else {

    var detail:any={
      "phone_code": this.CurrentDetail.phone_code,
      "mobile": this.CurrentDetail.org_phone,
      "otp": this.otp
    }
    var url="/mobile-verify-otp";
    this.loading=true;
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success){
        this.loading=false;
        $('#closebtn1').trigger('click');
        this.service.successAlert(response.message);
        this.CurrentDetail.is_mobile_verified=true;
        this.otp='';
      } else {
        this.service.dangerAlert(response.message);
        this.loading=false;
      }
    }))
  }
  }

  startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.pauseTimer();
      }
    },1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  onOtpChange(otp: any) {
    this.otp = otp;
  }

  Resendotp(){}

  colorChnage(event:any){ 
    this.colorList.filter((el:any)=>{
      if(el._id == event.value){
        var mm:any = document.getElementById("tab45");
        if (mm) {
          mm.style["background-color"] = el.color ;
        }
      }
    })    
  }

  getterm(){
    const url = "/term-conditions"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.termData = response.data;
      }
    }), (error) => { this.loading =false; });
  }

  onDragOver(event: any) {
    event.preventDefault();
  }

  // From drag and drop
  onDropSuccess(event: any): void {
    this.imageChangedEvent = event;
    event.preventDefault();
    this.getUploadFileDetail(event.dataTransfer.files);    // notice the "dataTransfer" used instead of "target"
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl || event.base64 || '');
    console.log(event);
  }

  imageCropped1(event: any) {
    var reader = new FileReader();
    reader.readAsDataURL(event.blob);
    const self = this;
    reader.onloadend = function () {
      var base64data = reader.result;
      self.croppedImage1 = base64data;
    }
    console.log(self.croppedImage1);
  }

  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

  cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    this.loading = false;
  }

  loadImageFailed() {
    console.error('Load image failed');
  }


  changeImage1(event: any) {
    this.imageChangedEvent = event;
    // this.getUploadFileDetail(event.target.files);
  }

  
} 
